import React, { useEffect, useState } from "react";
import "./signIn.scss";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import brandStore from "../../store/brandStore";
import snackbarStore from "../../store/snackbarStore";
import SnackbarAlert from "../../components/snackbarAlert/snackbarAlert";
import authStore from "../../store/authStore";
import { LoadingButton } from "@mui/lab";

// Icons
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { BRAND_NAME_LOGO } from "../../constant";
import SEO from "components/seo/SEO";

const SignIn = () => {
  const navigate = useNavigate();
  const AuthStore = authStore();
  const BrandStore = brandStore();
  const SnackbarStore = snackbarStore();
  const isNonMobile = useMediaQuery("(min-width: 600px)");
  const [isLoading, setIsLoading] = useState(false);
  const [isEmail, setIsEmail] = useState(false);
  const [isPassword, setIsPassword] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [alertColor, setAlertColor] = useState(null);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  useEffect(() => {
    if (SnackbarStore.massage !== "") {
      SnackbarStore.setIsOpen({ value: true });
    }
  }, [SnackbarStore.massage]);

  const onSignIn = async () => {
    let flag = 0;

    if (AuthStore.signInForm.email === "") {
      setIsEmail(true);
      flag++;
    } else {
      const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (reg.test(AuthStore.signInForm.email) === true) {
        setIsEmail(false);
      } else {
        setIsEmail(true);
        flag++;
      }
    }
    if (AuthStore.signInForm.password === "") {
      setIsPassword(true);
      flag++;
    } else {
      setIsPassword(false);
    }

    if (flag !== 0) {
      return false;
    }

    setIsLoading(true);
    if (
      AuthStore.signInForm.email === process.env.REACT_APP_TEST_EMAIL &&
      AuthStore.signInForm.password === process.env.REACT_APP_TEST_PASSWORD
    ) {
      const res = await AuthStore.signIn();
      if (res) {
        setIsLoading(false);
        navigate("/");
      } else {
        setIsLoading(false);
      }
    } else {
      const res = await AuthStore.emailIsExistsForSignIn();
      setIsLoading(false);
      if (res) {
        // navigate("/");
        navigate("/verification/sign-in");
      } else {
        setAlertColor("error");
      }
    }
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Grid
      container
      component="main"
      className="sign-in"
      sx={{ p: isNonMobile ? "50px" : 0 }}
    >
      <SEO
        title="Sign In | KRISTIVE"
        description="Sign in to your KRISTIVE account to access your profile, orders, and favorite fragrances."
      />
      <SnackbarAlert
        isOpen={SnackbarStore.isOpen}
        alertVariant="filled"
        onClose={() => {
          SnackbarStore.setIsOpen({ value: false });
          SnackbarStore.setMassage({ value: "" });
          setAlertColor(null);
        }}
        alertSeverity={alertColor}
        // alertColor={alertColor}
        massage={SnackbarStore.massage}
      />
      <Grid item xs={12} sm={12} md={6} className="container">
        <Box component="div" className="brand-name-logo-container">
          <Link to={"/"} component="div" className="brand-name-logo">
            <img src={BRAND_NAME_LOGO} alt="brand-logo" />
          </Link>
        </Box>
        <Box component="div" className="content">
          <Typography component="h1" variant="h5" className="title">
            Sign In
          </Typography>
          <Box component="form" noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              name="email"
              label="Email Address"
              autoComplete="email"
              autoFocus
              type="email"
              error={isEmail}
              helperText={isEmail && "Email is require"}
              value={AuthStore.signInForm.email}
              onChange={AuthStore.fillSignInForm}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type={showCurrentPassword ? "text" : "password"}
              autoComplete="current-password"
              error={isPassword}
              helperText={isPassword && "Password is require"}
              value={AuthStore.signInForm.password}
              onChange={AuthStore.fillSignInForm}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() =>
                        setShowCurrentPassword(!showCurrentPassword)
                      }
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showCurrentPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember Me"
            />
            <LoadingButton
              loading={isLoading}
              type="button"
              fullWidth
              variant="contained"
              className="btn"
              onClick={onSignIn}
            >
              Sign In
            </LoadingButton>
            <Grid container>
              <Grid item xs>
                <Link
                  to="/forgot-password"
                  className="go-to-forgot-password link"
                >
                  Forgot Password?
                </Link>
              </Grid>
              <Grid item>
                <Link to="/sign-up" className="go-to-sign-up link">
                  Don't Have an account? Sign Up
                </Link>
              </Grid>
            </Grid>
            <Typography
              variant="body2"
              color="text.secondary"
              align="center"
              className="copy-right"
            >
              Copyright © {currentYear} {BrandStore.brand.brandName}. All rights reserved.
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default SignIn;
